module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', {
    staticClass: "page-header"
  }, [_c('span', {
    attrs: {
      "id": "page-header"
    }
  }, [_vm._v(_vm._s(_vm.pageheader))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "col-lg-12"
  }, [_vm._v("Allgemeine Informationen  "), _c('router-link', {
    staticClass: "btn btn-primary create-new pull-right",
    attrs: {
      "to": "/users/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "customer-information"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Vorname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.firstname),
      expression: "model.model.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "firstname",
      "name": "firstname",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.firstname = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Nachname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.lastname),
      expression: "model.model.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "lastname",
      "name": "lastname",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.lastname = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Loginname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.username),
      expression: "model.model.username"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "username",
      "name": "username",
      "readonly": _vm.model.model.id === 0 ? null : 'readonly',
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.username = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Passwort")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.password),
      expression: "model.model.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "name": "password",
      "type": "password",
      "placeholder": _vm.model.model.id === 0 ? 'Passwort eingeben' : '[Nicht ändern]',
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.password = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "repassword"
    }
  }, [_vm._v("Passwort wiederholen")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.repassword),
      expression: "model.model.repassword"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "repassword",
      "name": "password",
      "type": "password",
      "placeholder": _vm.model.model.password === '' ? '[Nicht ändern]' : 'Passwort wiederholen',
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.repassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.repassword = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "superior"
    }
  }, [_vm._v("Vorgesetzter")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.isSuperadmin()) ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.superior_name),
      expression: "model.model.superior_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "superior",
      "name": "superior",
      "required": "required",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.model.model.superior_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.superior_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon addon-primary",
    on: {
      "click": function($event) {
        _vm.selectSuperior()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.isSuperadmin()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.superior_name),
      expression: "model.model.superior_name"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.model.model.superior_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.superior_name = $event.target.value
      }
    }
  }) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "role"
    }
  }, [_vm._v("Rolle")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.role_name),
      expression: "model.model.role_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "role",
      "name": "role",
      "required": "required",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.model.model.role_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.role_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon addon-primary",
    on: {
      "click": function($event) {
        _vm.selectRole()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.saveUser()
      }
    }
  }, [_vm._v("Speichern")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tab-content col-lg-12"
  }, [_c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "addresses"
    }
  }, [_c('custom-table', {
    attrs: {
      "cols": _vm.addresses.cols,
      "src-model": _vm.model.addresses,
      "add": "",
      "delete": "",
      "edit": "",
      "nosort": ""
    },
    on: {
      "add": _vm.addAddress,
      "edit": _vm.editAddress,
      "delete": _vm.deleteAddress
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "contacts"
    }
  }, [_c('custom-table', {
    attrs: {
      "cols": _vm.contacts.cols,
      "src-model": _vm.model.contacts,
      "add": "",
      "delete": "",
      "edit": "",
      "nosort": ""
    },
    on: {
      "add": _vm.addContact,
      "edit": _vm.editContact,
      "delete": _vm.deleteContact
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "permissions"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Dashboard")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "dashboard",
    on: {
      "callback": function($event) {
        _vm.changeIndex('dashboard')
      }
    },
    model: {
      value: (_vm.model.model.rightValues.dashboard),
      callback: function($$v) {
        _vm.model.model.rightValues.dashboard = $$v
      },
      expression: "model.model.rightValues.dashboard"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.model.model.role.dashboard))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Verstorbene")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "deceaseds",
    on: {
      "callback": function($event) {
        _vm.changeIndex('deceaseds')
      }
    },
    model: {
      value: (_vm.model.model.rightValues.deceaseds),
      callback: function($$v) {
        _vm.model.model.rightValues.deceaseds = $$v
      },
      expression: "model.model.rightValues.deceaseds"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.model.model.role.deceaseds))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kunden")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "customers",
    on: {
      "callback": function($event) {
        _vm.changeIndex('customers')
      }
    },
    model: {
      value: (_vm.model.model.rightValues.customers),
      callback: function($$v) {
        _vm.model.model.rightValues.customers = $$v
      },
      expression: "model.model.rightValues.customers"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.model.model.role.customers))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Gräber")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "graves",
    on: {
      "callback": function($event) {
        _vm.changeIndex('graves')
      }
    },
    model: {
      value: (_vm.model.model.rightValues.graves),
      callback: function($$v) {
        _vm.model.model.rightValues.graves = $$v
      },
      expression: "model.model.rightValues.graves"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.model.model.role.graves))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Flächen")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "areas",
    on: {
      "callback": function($event) {
        _vm.changeIndex('areas')
      }
    },
    model: {
      value: (_vm.model.model.rightValues.areas),
      callback: function($$v) {
        _vm.model.model.rightValues.areas = $$v
      },
      expression: "model.model.rightValues.areas"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.model.model.role.areas))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Krematorien")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "crematories",
    on: {
      "callback": function($event) {
        _vm.changeIndex('crematories')
      }
    },
    model: {
      value: (_vm.model.model.rightValues.crematories),
      callback: function($$v) {
        _vm.model.model.rightValues.crematories = $$v
      },
      expression: "model.model.rightValues.crematories"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.model.model.role.crematories))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bestatter")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "undertakers",
    on: {
      "callback": function($event) {
        _vm.changeIndex('undertakers')
      }
    },
    model: {
      value: (_vm.model.model.rightValues.undertakers),
      callback: function($$v) {
        _vm.model.model.rightValues.undertakers = $$v
      },
      expression: "model.model.rightValues.undertakers"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.model.model.role.undertakers))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Benutzerverwaltung")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "users",
    on: {
      "callback": function($event) {
        _vm.changeIndex('users')
      }
    },
    model: {
      value: (_vm.model.model.rightValues.users),
      callback: function($$v) {
        _vm.model.model.rightValues.users = $$v
      },
      expression: "model.model.rightValues.users"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.model.model.role.users))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Rollen")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "roles",
    on: {
      "callback": function($event) {
        _vm.changeIndex('roles')
      }
    },
    model: {
      value: (_vm.model.model.rightValues.roles),
      callback: function($$v) {
        _vm.model.model.rightValues.roles = $$v
      },
      expression: "model.model.rightValues.roles"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.model.model.role.roles))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Flächenarten")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "area_categories",
    on: {
      "callback": function($event) {
        _vm.changeIndex('area_categories')
      }
    },
    model: {
      value: (_vm.model.model.rightValues.area_categories),
      callback: function($$v) {
        _vm.model.model.rightValues.area_categories = $$v
      },
      expression: "model.model.rightValues.area_categories"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.model.model.role.area_categories))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Grabarten")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "grave_categories",
    on: {
      "callback": function($event) {
        _vm.changeIndex('grave_categories')
      }
    },
    model: {
      value: (_vm.model.model.rightValues.grave_categories),
      callback: function($$v) {
        _vm.model.model.rightValues.grave_categories = $$v
      },
      expression: "model.model.rightValues.grave_categories"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.model.model.role.grave_categories))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bestattungsarten")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "burial_types",
    on: {
      "callback": function($event) {
        _vm.changeIndex('burial_types')
      }
    },
    model: {
      value: (_vm.model.model.rightValues.burial_types),
      callback: function($$v) {
        _vm.model.model.rightValues.burial_types = $$v
      },
      expression: "model.model.rightValues.burial_types"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.model.model.role.burial_types))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Konfessionen")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "denominations",
    on: {
      "callback": function($event) {
        _vm.changeIndex('denominations')
      }
    },
    model: {
      value: (_vm.model.model.rightValues.denominations),
      callback: function($$v) {
        _vm.model.model.rightValues.denominations = $$v
      },
      expression: "model.model.rightValues.denominations"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.model.model.role.denominations))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Friedhofsverwaltung")]), _vm._v(" "), _c('td', [_c('vue-slider', _vm._b({
    ref: "graveyards",
    on: {
      "callback": function($event) {
        _vm.changeIndex('graveyards')
      }
    },
    model: {
      value: (_vm.model.model.rightValues.graveyards),
      callback: function($$v) {
        _vm.model.model.rightValues.graveyards = $$v
      },
      expression: "model.model.rightValues.graveyards"
    }
  }, 'vue-slider', _vm.sliderTemplate, false))], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.model.model.role.graveyards))])])])])])])])])])])])]), _vm._v(" "), (_vm.visibleModal === 'selectsuperior') ? _c('custom-modal-old', {
    attrs: {
      "title": "Vorgesetzen auswählen"
    },
    on: {
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('custom-table', {
    attrs: {
      "select": "",
      "src-model": _vm.$store.getters.models('users'),
      "cols": _vm.superiorSearchCols,
      "store": "categories",
      "search": "",
      "default-sort": _vm.defSort
    },
    on: {
      "select": _vm.pickSuperior
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'selectrole') ? _c('custom-modal-old', {
    attrs: {
      "title": "Rolle auswählen"
    },
    on: {
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('custom-table', {
    attrs: {
      "select": "",
      "src-model": _vm.$store.getters.models('roles'),
      "cols": _vm.roleSearchCols,
      "store": "categories",
      "search": "",
      "default-sort": _vm.defSort
    },
    on: {
      "select": _vm.pickRole
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('custom-modal', {
    ref: "addressModal",
    attrs: {
      "title": "Adresse hinzufügen",
      "ok-text": "Speichern",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-primary",
      "cancel-style": "btn btn-default"
    }
  }, [_c('address-content', {
    ref: "newAddress"
  })], 1), _vm._v(" "), (_vm.visibleModal === 'deleteaddresses') ? _c('custom-modal-old', {
    attrs: {
      "title": "Adresse löschen",
      "ok-text": "Löschen",
      "cancel-text": "Abbrechen",
      "cancel-style": "btn btn-primary",
      "ok-style": "btn btn-danger"
    },
    on: {
      "ok": function($event) {
        _vm.confirmDeleteRelation('addresses')
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('strong', [_vm._v("Sind Sie sicher, dass Sie diese Adresse entfernen möchten?")])]) : _vm._e(), _vm._v(" "), _c('custom-modal', {
    ref: "contactModal",
    attrs: {
      "title": "Kontakt hinzufügen",
      "ok-text": "Speichern",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-primary",
      "cancel-style": "btn btn-default"
    }
  }, [_c('contact-content', {
    ref: "newContact"
  })], 1), _vm._v(" "), (_vm.visibleModal === 'deletecontacts') ? _c('custom-modal-old', {
    attrs: {
      "title": "Kontakt entfernen",
      "ok-text": "Löschen",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-danger"
    },
    on: {
      "ok": function($event) {
        _vm.confirmDeleteRelation('contacts')
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('strong', [_vm._v("Sind Sie sicher, dass Sie diesen Kontakt entfernen möchten?")])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'errSavingModel') ? _c('custom-modal-old', {
    attrs: {
      "ok-text": "OK"
    },
    on: {
      "ok": function($event) {
        _vm.visibleModal = ''
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_vm._v("\r\n\t\t\tFehler beim Speichern des Kunden.\r\n\t\t")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "hidden-md hidden-lg",
    attrs: {
      "href": "/users/"
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Zur Liste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "hidden-sm hidden-xs",
    attrs: {
      "href": "/users/"
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Zur Liste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs responsive-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#permissions"
    }
  }, [_vm._v("Zugriffsstufen")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#addresses"
    }
  }, [_vm._v("Adressen")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#contacts"
    }
  }, [_vm._v("Kontakte")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("Bereich")]), _vm._v(" "), _c('th', [_vm._v("Berechtigungsstufe")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("Rolle")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a5a82d78!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserEdit.vue
// module id = 461
// module chunks = 0